import { StyledText, StyledWrapper } from "./styles";

import { ReactComponent as EmptyBoxSvg } from "./empty-box.svg";
import { useLanguage } from "../../context/LocaleProvider";
const EmptyBox = () => {
  const { feelingEmpty } = useLanguage();
  return (
    <StyledWrapper>
      <EmptyBoxSvg />
      <StyledText>{feelingEmpty}</StyledText>
    </StyledWrapper>
  );
};

export default EmptyBox;
